// The remove button is revealed by hover or by keyboard focus anywhere in the chip. `opacity`, not
// `display: none`, so it stays in the tab order and keeps its width (no layout shift on reveal).
.remove {
  opacity: 0;
}

.chip:hover .remove,
.chip:focus-within .remove {
  opacity: 1;
}

// A touch screen has no hover to reveal it.
@media (hover: none) {
  .remove {
    opacity: 1;
  }
}
